import { useSelector, shallowEqual } from 'react-redux';

import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { selectElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';
import { useHasSmartMeter } from 'components/direct-sales/quote/hooks/useHasSmartMeter';
import { useMeterType } from 'hooks/useMeterType';
import { useConsumption } from 'hooks/useConsumption';
import { usePaymentMethod } from 'hooks/usePaymentMethod';
import { useFmrs } from 'hooks/useFmrs';

export const getMeterType = (hasSmartMeter, hasE7Meter) => {
  switch (true) {
    case hasSmartMeter:
      return 'smart';
    case hasE7Meter:
      return 'multi-rate';
    default:
      return 'standard';
  }
};

export const getFuelType = (electricity, gas) => {
  switch (true) {
    case gas && electricity:
      return 'dual';
    case gas:
      return 'gas';
    case electricity:
      return 'electricity';
    default:
      return '';
  }
};

export const useJourneyData = () => {
  const { consumption } = useConsumption();
  const { hasAllSmartMeter } = useHasSmartMeter();
  const address = useSelector(selectedAddress, shallowEqual) || {};

  const fuelType = useSelector(selectFuelType, shallowEqual);
  const electricVehicle = useSelector(selectElectricVehicle, shallowEqual);
  const { preferredStartDate } = useFmrs();
  const { paymentMethod } = usePaymentMethod();
  const {
    electricityMeter = {},
    gasMeter = {},
    hasE7Meter,
    hasAnyPrepayMeter
  } = useMeterType();
  const { postcode } = address;
  const { gas, electric } = fuelType;
  const meterType = getMeterType(hasAllSmartMeter, hasE7Meter);
  const fuelTypeString = getFuelType(electric, gas);

  return {
    address,
    consumption,
    fuelType,
    postcode,
    hasSmartMeter: hasAllSmartMeter,
    hasE7Meter,
    electricVehicle,
    mpan: electricityMeter.meterPointNumber,
    mprn: gasMeter.meterPointNumber,
    hasAnyPrepayMeter,
    meterType,
    fuelTypeString,
    preferredStartDate,
    paymentMethod
  };
};
